import { render, staticRenderFns } from "./form-table-row.vue?vue&type=template&id=086018a0&scoped=true&"
import script from "./form-table-row.vue?vue&type=script&lang=js&"
export * from "./form-table-row.vue?vue&type=script&lang=js&"
import style0 from "./form-table-row.vue?vue&type=style&index=0&id=086018a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086018a0",
  null
  
)

export default component.exports